module.exports = __webpack_public_path__ + "img/intensity_mappting_after.3d855182.png";